





















































































import {
  computed, defineComponent, reactive, ref,
} from '@vue/composition-api';
import { useFormat } from 'vivat';
import { useQuery, useResult } from '@vue/apollo-composable';

import useHighChartMap from '@/useHighChartMap';

import getDeliveryCostIndex from '@/gql/report/analytic/getDeliveryCostIndex.gql';

import Heatmap from '@/components/Map/Heatmap.vue';
import CommonIconTop from '@/components/CommonIconTop.vue';

const NOW = new Date();

const AverageExpense = defineComponent({
  components: {
    Heatmap,
    CommonIconTop,
  },
  setup() {
    const { getProperty } = useHighChartMap();
    const toDate = (date: string) => useFormat.date(date).displayFullThaiDate();
    const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const toWeightFormat = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { maximumFractionDigits: 0 });
    const getYear = (date: string) => useFormat.date(date).dayjs.get('year');
    const backwardTenYear = Array.from({ length: 10 }, (x, i) => new Date().getFullYear() + 543 - i);
    const filter = reactive({
      range: {
        from: useFormat.date(NOW).computerShortDate(),
        to: useFormat.date(NOW).computerShortDate(),
      },
    });
    const computedFilter = computed(() => {
      if (filter.range.from === filter.range.to) return {};
      return {
        range: {
          from: useFormat.date(filter.range.from).computerShortDate(),
          to: useFormat.date(filter.range.to).computerShortDate(),
        },
      };
    });

    const { result: getDeliveryCostIndexResult } = useQuery(getDeliveryCostIndex, () => ({
      timeframe: computedFilter.value.range,
    }));
    const packageDeliveryCostIndex = useResult(getDeliveryCostIndexResult, [], (data) => data.packageDeliveryCostIndex);
    const deliveryCostIndex = useResult(getDeliveryCostIndexResult, [], (data) => data.deliveryCostIndex);

    const thMonthsMini = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];
    const selectedYear = ref(new Date().getFullYear() + 543);
    const computedSeriesData = computed(() => {
      const bahtPerPiece: any[] = [];
      const bahtPerKg: any[] = [];
      const bahtPerKm: any[] = [];
      const bahtPerPack: any[] = [];
      const sum: any = {
        bahtPerPiece: 0,
        bahtPerKg: 0,
        bahtPerKm: 0,
        bahtPerPack: 0,
      };

      deliveryCostIndex.value.forEach((val: any) => {
        bahtPerPiece.push({
          x: thMonthsMini[val.month - 1],
          y: val.bahtPerPiece,
        });
        bahtPerKg.push({
          x: thMonthsMini[val.month - 1],
          y: val.bahtPerKg,
        });
        bahtPerKm.push({
          x: thMonthsMini[val.month - 1],
          y: val.bahtPerKm,
        });
        bahtPerPack.push({
          x: thMonthsMini[val.month - 1],
          y: val.bahtPerPack,
        });
        sum.bahtPerPiece += val.bahtPerPiece;
        sum.bahtPerKg += val.bahtPerKg;
        sum.bahtPerKm += val.bahtPerKm;
        sum.bahtPerPack += val.bahtPerPack;
      });

      return {
        bahtPerPiece,
        bahtPerKg,
        bahtPerKm,
        bahtPerPack,
        sum,
      };
    });

    const areaCharts = computed(() => ({
      options: {
        dataLabels: { enabled: false },
        yaxis: {
          opposite: false,
          labels: {
            formatter: (val: any) => toCurrency(val),
          },
        },
      },
      series: [
        {
          name: 'บาท/ชิ้น',
          data: computedSeriesData.value.bahtPerPiece,
        },
        {
          name: 'บาท/น้ำหนัก',
          data: computedSeriesData.value.bahtPerKg,
        },
        {
          name: 'บาท/ระยะทาง',
          data: computedSeriesData.value.bahtPerKm,
        },
        {
          name: 'บาท/หีบห่อ',
          data: computedSeriesData.value.bahtPerPack,
        },
      ],
    }));

    const computedPackageDeliveryCostIndex = computed(() => {
      const totalWeight = packageDeliveryCostIndex.value
        .reduce((previousValue: any, currentValue: any) => previousValue + currentValue.weight, 0);

      return packageDeliveryCostIndex.value.map((packageDeliveryCost: { bahtPerKg: number; unit: string; weight: number; volume: number }) => ({
        percent: (packageDeliveryCost.weight / totalWeight) * 100,
        bahtPerKg: packageDeliveryCost.bahtPerKg,
        unit: packageDeliveryCost.unit,
        weight: packageDeliveryCost.weight,
        volume: packageDeliveryCost.volume,
      })).sort((elm: any, elm2: any) => elm2.percent - elm.percent);
    });

    return {
      toCurrency,
      toWeightFormat,
      toDate,
      getYear,
      filter,

      areaCharts,
      backwardTenYear,
      selectedYear,

      computedSeriesData,
      computedPackageDeliveryCostIndex,
    };
  },
});

export default AverageExpense;
